import { render, staticRenderFns } from "./booksReadMobile.vue?vue&type=template&id=4bcba15e&"
import script from "./booksReadMobile.vue?vue&type=script&lang=js&"
export * from "./booksReadMobile.vue?vue&type=script&lang=js&"
import style0 from "./booksReadMobile.vue?vue&type=style&index=0&id=4bcba15e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports